import { combineReducers } from "redux";
import uploadModel from "./uploadModelReducer";
import languages from "./laguagesReducer";
import control from "./controlReducer";
import uploadFile from "./uploadFileReducer";
import translationModel from "./translationReducer";
import segments from "./segmentsReducer";
import validation from "./validationReducer";

const rootReducer = combineReducers({
  uploadModel,
  languages,
  control,
  uploadFile,
  translationModel,
  segments,
  validation,
});

export default rootReducer;
